const LOG_LEVEL_ERROR = 10
const LOG_LEVEL_WARN = 20
const LOG_LEVEL_INFO = 30
const LOG_LEVEL_DEBUG = 40

export default {
  LOG_LEVEL_ERROR: LOG_LEVEL_ERROR,
  LOG_LEVEL_WARN: LOG_LEVEL_WARN,
  LOG_LEVEL_INFO: LOG_LEVEL_INFO,
  LOG_LEVEL_DEBUG: LOG_LEVEL_DEBUG,
  install: function (Vue, opt = {}) {
    let level = parseInt(opt.level)
    if (isNaN(level)) {
      level = LOG_LEVEL_INFO
    }
    Vue.prototype.$log = {
      error: level >= LOG_LEVEL_ERROR ? console.error.bind(console, '[CCS-ERROR]') : function () {},
      warn: level >= LOG_LEVEL_WARN ? console.warn.bind(console, '[CCS-WARN]') : function () {},
      info: level >= LOG_LEVEL_INFO ? console.info.bind(console, '[CCS-INFO]') : function () {},
      debug: level >= LOG_LEVEL_DEBUG ? console.debug.bind(console, '[CCS-DEBUG]') : function () {}
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/logger.js